import NavBar from './components/NavBar/NavBar';
import Hero from './components/Hero/Hero';
import WhyRideWithUs from './components/WhyRideWithUs/WhyRideWithUs';
import OurScooters from './components/OurScooters/OurScooters';
import HowItWorks from './components/HowItWorks/HowItWorks';
import PricingSection from './components/PricingSection/PricingSection';
import Delivery from './components/Delivery/Delivery';
import PolicySection from './components/PolicySection/PolicySection';
import Reviews from './components/Reviews/Reviews';
import CustomerPhotos from './components/CustomerPhotos/CustomerPhotos';
import ComfortFeatures from './components/ComfortFeatures/ComfortFeatures';
import Insta360Section from './components/Insta360Section/Insta360Section';
import AdventurePackSection from './components/AdventurePackSection/AdventurePackSection';
import FAQ from './components/FAQ/FAQ';
import BookCTA from './components/BookCTA/BookCTA';
import Footer from './components/Footer/Footer';
import StickyWhatsApp from './components/StickyWhatsApp/StickyWhatsApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Hero />
      <WhyRideWithUs />
      <OurScooters />
      <HowItWorks />
      <PricingSection />
      <Delivery />
      <PolicySection />
      <Reviews />
      <CustomerPhotos />
      <ComfortFeatures />
      <Insta360Section />
      <AdventurePackSection />
      <FAQ />
      <BookCTA />
      <Footer />
      <StickyWhatsApp />
    </div>
  );
}

export default App;
